import * as React from "react";
import { Link } from "react-router-dom";
import "../../stylesheets/components/header/nav/navMob.scss";
import "../../assets/icons/edel_icons/style.scss";
import { useDispatch, useSelector } from "react-redux";
import { symbols } from "../../constant/symbols";
import logo from "../../assets/images/generic/nuvama_logo.png";
import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import di from "@di";
import Drawer from "react-bottom-drawer";
import LoginRegister from "../../components/features/LoginFlow/LoginRegisterPage";
import { LoginLogoutDropdown } from "@frameworks/web/components/features/LoginFlow/ClientUser/LoginLogoutDropdown";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
const MobStockNav = (props) => {
    return (React.createElement("div", { className: "bottom-nav-tile1" },
        React.createElement("span", { className: "txt_primaryGrey mb-0 DMSansMedium_12_500" }, props.label),
        React.createElement(ReportValue, { val: props.curPrice, stream: false, onlyval: false, parentClass: "txt_primaryGrey Roboto_12_400" }),
        React.createElement(ReportValue, { val: props.changePrice, stream: true, onlyval: false, parentClass: "RobotoM_12_500" }),
        React.createElement(ReportValue, { val: props.changePercentage, stream: true, onlyval: false, percentage: true, parentClass: "RobotoM_12_500" })));
};
const MobTopNav = () => {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.accountDetailsReducer.userID);
    const guestUserID = useSelector((state) => state.LoginFlow.guestValidateMPIN.data.guestId);
    const { showHeader, showFixedNavMob, scrollHeader } = useSelector((state) => state.header);
    const stream = useSelector((state) => state.header.stream);
    const [openPopUp, setOpenPopup] = React.useState(false);
    const [userID, setUserID] = React.useState();
    const [userType, setUserType] = React.useState();
    const [NSEObj, setNSEObj] = React.useState(React.createElement(MobStockNav, { label: symbols[1].EdelCode + " :", curPrice: "", changePrice: "", changePercentage: "", 
        // device={handleDevice}
        classList: "edel-icon-caret-up" }));
    const [BSEObj, setBSEObj] = React.useState(React.createElement(MobStockNav, { label: symbols[0].EdelCode + " :", curPrice: "", changePrice: "", changePercentage: "", 
        // device={handleDevice}
        classList: "edel-icon-caret-up" }));
    React.useEffect(() => {
        if (openPopUp) {
            dispatch(di.footer.updateShowMob_Menu(false));
            di.header.RemoveHeaderData(false);
        }
        else {
            dispatch(di.footer.updateShowMob_Menu(true));
            di.header.RemoveHeaderData(true);
        }
    }, [openPopUp]);
    React.useEffect(() => {
        if (stream.length > 0) {
            try {
                stream.map((streamData) => {
                    const symbol = symbols.find((symCodes) => streamData.symbol === symCodes.symbol);
                    switch (streamData.symbol) {
                        case "-101":
                            setBSEObj(React.createElement(MobStockNav, { label: symbol.EdelCode + " :", curPrice: streamData.curPrice, changePrice: streamData.changePrice, changePercentage: streamData.changePercentage }));
                            break;
                        case "-29":
                            setNSEObj(React.createElement(MobStockNav, { label: symbol.EdelCode + " :", curPrice: streamData.curPrice, changePrice: streamData.changePrice, changePercentage: streamData.changePercentage }));
                            break;
                        default:
                            "";
                    }
                });
            }
            catch (err) {
                console.log(err);
            }
        }
    }, [stream]);
    let checkUserData = async () => {
        if (!!userId) {
            setUserType(ILoginFlows.CLIENT);
            setUserID(userId);
        }
        else {
            setUserType(ILoginFlows.GUEST);
            setUserID(guestUserID);
        }
    };
    React.useEffect(() => {
        checkUserData();
    }, [userId, guestUserID]);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: `mob-fixed-header1 ${scrollHeader ? "" : "position-sticky"}`, style: { display: showFixedNavMob ? "block" : "none" } },
            React.createElement("section", { className: "header-container" },
                React.createElement("div", { className: "top-nav-block" },
                    React.createElement("div", { className: "top-nav-left" },
                        React.createElement(Link, { to: "" },
                            React.createElement("img", { src: logo, alt: "nuvama" }))),
                    React.createElement("div", { className: "top-nav-right" },
                        React.createElement("div", { className: "ml-40" }, userID ? (React.createElement("span", { onClick: () => setOpenPopup(true) },
                            React.createElement("div", { className: "signup-block" }, userID.substring(0, 3)))) : (React.createElement("span", { className: " edel-icon-user2 user2-logo" },
                            React.createElement("i", { className: "edel-icon-arrow-down", onClick: () => setOpenPopup(true) }))))))),
            React.createElement("div", { className: "mb-genericSidebar support-genericSidebar support-content-drp mobiletopnav" },
                React.createElement(Drawer, { isVisible: openPopUp, onClose: () => setOpenPopup(false), hideScrollbars: true, className: "drawer__handle-wrapper z-index-high backgroundcolor_bluedrawer" }, !!userID
                    ? openPopUp && (React.createElement(LoginLogoutDropdown, { userName: userID, userType: userType }))
                    : openPopUp && React.createElement(LoginRegister, { setOpenPopup: setOpenPopup })))),
        React.createElement("header", { className: `mob-fixed-header2 ${scrollHeader ? "" : "position-sticky "} ${showHeader ? " d-block " : " d-none"}` },
            React.createElement("section", { className: "header-container-1" },
                React.createElement("div", { className: "bottom-nav-block" },
                    NSEObj,
                    BSEObj)))));
};
export default MobTopNav;
